import Vue from 'vue'
import VueI18n from 'vue-i18n'

import bs from './lang/bs.json';
import hr from './lang/bs.json';
import sr from './lang/sr.json';


Vue.use(VueI18n)

const messages = {
  bs: bs,
  hr: hr,
  sr: sr,
}

const locale = localStorage.getItem('language') ? localStorage.getItem('language') : 'bs'

const i18n = new VueI18n({
  locale: locale, // set locale
  fallbackLocale: 'bs',
  messages: messages // set locale messages
})

export default i18n




